/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedOccupancyStatsResponseLeadsCountByBedTypeInner } from './BedOccupancyStatsResponseLeadsCountByBedTypeInner';
import {
    BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSON,
    BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSONTyped,
    BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSON,
    BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSONTyped,
} from './BedOccupancyStatsResponseLeadsCountByBedTypeInner';
import type { BedOccupancyStatsResponseGenderDistribution } from './BedOccupancyStatsResponseGenderDistribution';
import {
    BedOccupancyStatsResponseGenderDistributionFromJSON,
    BedOccupancyStatsResponseGenderDistributionFromJSONTyped,
    BedOccupancyStatsResponseGenderDistributionToJSON,
    BedOccupancyStatsResponseGenderDistributionToJSONTyped,
} from './BedOccupancyStatsResponseGenderDistribution';

/**
 * 
 * @export
 * @interface BedOccupancyStatsResponse
 */
export interface BedOccupancyStatsResponse {
    /**
     * 
     */
    facility_id: string;
    /**
     * Total number of moved-in screener leads
     */
    moved_in_leads_count: number;
    /**
     * Total number of hospitalized screener leads
     */
    hospitalized_leads_count: number;
    /**
     * 
     */
    leads_count_by_bed_type: Array<BedOccupancyStatsResponseLeadsCountByBedTypeInner>;
    /**
     * 
     */
    gender_distribution: BedOccupancyStatsResponseGenderDistribution;
}

/**
 * Check if a given object implements the BedOccupancyStatsResponse interface.
 */
export function instanceOfBedOccupancyStatsResponse(value: object): value is BedOccupancyStatsResponse {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('moved_in_leads_count' in value) || value['moved_in_leads_count'] === undefined) return false;
    if (!('hospitalized_leads_count' in value) || value['hospitalized_leads_count'] === undefined) return false;
    if (!('leads_count_by_bed_type' in value) || value['leads_count_by_bed_type'] === undefined) return false;
    if (!('gender_distribution' in value) || value['gender_distribution'] === undefined) return false;
    return true;
}

export function BedOccupancyStatsResponseFromJSON(json: any): BedOccupancyStatsResponse {
    return BedOccupancyStatsResponseFromJSONTyped(json, false);
}

export function BedOccupancyStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedOccupancyStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'moved_in_leads_count': json['moved_in_leads_count'],
        'hospitalized_leads_count': json['hospitalized_leads_count'],
        'leads_count_by_bed_type': ((json['leads_count_by_bed_type'] as Array<any>).map(BedOccupancyStatsResponseLeadsCountByBedTypeInnerFromJSON)),
        'gender_distribution': BedOccupancyStatsResponseGenderDistributionFromJSON(json['gender_distribution']),
    };
}

export function BedOccupancyStatsResponseToJSON(json: any): BedOccupancyStatsResponse {
    return BedOccupancyStatsResponseToJSONTyped(json, false);
}

export function BedOccupancyStatsResponseToJSONTyped(value?: BedOccupancyStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'moved_in_leads_count': value['moved_in_leads_count'],
        'hospitalized_leads_count': value['hospitalized_leads_count'],
        'leads_count_by_bed_type': ((value['leads_count_by_bed_type'] as Array<any>).map(BedOccupancyStatsResponseLeadsCountByBedTypeInnerToJSON)),
        'gender_distribution': BedOccupancyStatsResponseGenderDistributionToJSON(value['gender_distribution']),
    };
}

